import * as React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { graphql, useStaticQuery } from "gatsby";
import Close from "./close";
import ButtonLink from "./button-link";

const query = graphql`
  query {
    allContentfulLink(
      filter: {
        metadata: {
          tags: { elemMatch: { name: { eq: "downloadCatalogHeader" } } }
        }
      }
    ) {
      nodes {
        node_locale
        id
        button
        buttonBackgroundColour
        target
        textColour
        title
        link
        modal {
          ...Modal
        }
      }
    }
  }
`;

const Alert = ({ isOpen, onClose }) => {
  const { formatMessage, locale } = useIntl();
  const heading = formatMessage({ id: "alertHeading" });
  const { allContentfulLink } = useStaticQuery(query);

  const downloadButton = allContentfulLink.nodes.find(
    (item) => item.node_locale === locale
  );

  if (!isOpen) {
    return null;
  }

  return (
    <div className="header-alert" id="alert">
      <div className="container">
        <button className="header-alert-close" onClick={onClose}>
          <Close />
        </button>
        <div className="header-alert-text">
          <p dangerouslySetInnerHTML={{ __html: heading }} />
          <p>
            <FormattedMessage id="alertParagraph" />
          </p>
        </div>
        {downloadButton && (
          <ButtonLink
            className="header-alert-link"
            href={downloadButton.link}
            button={downloadButton.button}
            target={downloadButton.target}
            modal={downloadButton.modal}
          >
            {downloadButton.title}
          </ButtonLink>
        )}
      </div>
    </div>
  );
};

export default Alert;
